module.exports = __webpack_public_path__ + "img/fondo-banner-principal.cf008304.png";